<template>
    <div class="login-page">
        <!-- 顶部背景 -->
        <div class="login-header">
            <div class="logo-area" @click="toHome">
                <div class="logo-icon">🎯</div>
                <h1 class="logo-title">彩神论坛</h1>
                <p class="logo-desc">专家分析 · 精准预测</p>
            </div>
        </div>

        <!-- 登录表单 -->
        <div class="login-form">
            <van-form ref="loginForm" @submit="onSubmit">
                <!-- 用户名 -->
                <van-field v-model="form.name" name="name" label="用户名" placeholder="请输入用户名"
                    :rules="[{ required: true, message: '用户名不能为空' }]" left-icon="user-circle-o" clearable />

                <!-- 密码 -->
                <van-field v-model="form.password" name="password" label="密码" placeholder="请输入密码"
                    :rules="[{ required: true, message: '密码不能为空' }]" icon-prefix="my-icon" left-icon="jiesuo"
                    type="password" clearable />

                <!-- 验证码 -->
                <!-- <van-field
                    v-model="form.captcha"
                    name="captcha"
                    label="验证码"
                    placeholder="请输入验证码"
                    :rules="[{ required: true, message: '请输入验证码' }]"
                    left-icon="shield-o"
                    clearable
                >
                    <template #button>
                        <van-button
                            size="small"
                            type="primary"
                            @click="sendCaptcha"
                            :disabled="captchaDisabled"
                            class="captcha-btn"
                        >
                            {{ captchaText }}
                        </van-button>
                    </template>
</van-field> -->

                <!-- 登录按钮 -->
                <div class="form-actions">
                    <van-button round block type="primary" native-type="submit" :loading="loading" loading-text="登录中..."
                        class="login-btn">
                        登 录
                    </van-button>
                </div>

                <!-- 注册跳转 -->
                <div class="form-footer">
                    <span>还没有账号？</span>
                    <span class="link" @click="goToRegister">立即注册</span>
                </div>
            </van-form>
        </div>

        <!-- 其他登录方式 -->
        <div class="other-login">
            <div class="divider">
                <span>其他登录方式</span>
            </div>
            <div class="social-icons">
                <van-icon name="wechat" size="28" color="#07c160" @click="onWechatLogin" />
                <van-icon name="qq" size="28" color="#12b7f5" @click="onQQLogin" />
                <van-icon name="weibo" size="28" color="#ff8200" @click="onWeiboLogin" />
            </div>
        </div>
    </div>
</template>

<script>
import { Toast, Dialog } from 'vant';
import { auth } from '@/api';
import { SET_REDIRECT_URL, SET_USER } from '@/store/mutations-type';
import { mapState } from 'vuex';

export default {
    name: 'LoginPage',
    data() {
        return {
            form: {
                name: '',
                password: '',
                captcha: ''
            },
            loading: false,
            captchaDisabled: false,
            captchaCountdown: 60
        };
    },
    computed: {
        captchaText() {
            return this.captchaDisabled ? `${this.captchaCountdown}s` : '获取验证码';
        },
        ...mapState('login', ['redirectUrl'])
    },
    created() {
    },
    mounted() {
    },
    methods: {
        // 去主页
        toHome(){
            this.$router.replace('/home')
        },

        // 表单提交
        async onSubmit() {
            this.loading = true;
            try {
                const data = await auth.login(this.form.name, this.form.password);
                this.loading = false;

                Toast.success('登录成功');
                auth.saveToken(data);

                const redirectUrl = this.$route.query.redirectUrl || this.redirectUrl || '/';
                console.log(this.redirectUrl, this.$route.query.redirectUrl, redirectUrl);
                // 跳转
                this.$router.push(redirectUrl);
                // 跳转成功后，清除 Vuex 里的地址，防止干扰下一次登录
                this.$store.commit('login/' + [SET_REDIRECT_URL], null);
            } catch (error) {
                // 错误已经在拦截器中提示了，这里只需要处理额外的逻辑
                console.error('登录失败', error);
            } finally {
                this.loading = false;
            }
        },

        // 发送验证码
        sendCaptcha() {
            if (!this.form.username) {
                Toast('请先输入手机号');
                return;
            }
            if (!/^1[3-9]\d{9}$/.test(this.form.username)) {
                Toast('请输入正确的手机号');
                return;
            }

            this.captchaDisabled = true;
            Toast('验证码已发送');

            const timer = setInterval(() => {
                this.captchaCountdown--;
                if (this.captchaCountdown <= 0) {
                    clearInterval(timer);
                    this.captchaDisabled = false;
                    this.captchaCountdown = 60;
                }
            }, 1000);
        },

        // 跳转到注册
        goToRegister() {
            this.$router.push('/register');
        },

        // 第三方登录
        onWechatLogin() {
            Toast('即将对接，敬请期待');
        },
        onQQLogin() {
            Toast('即将对接，敬请期待');
        },
        onWeiboLogin() {
            Toast('即将对接，敬请期待');
        }
    }
};
</script>

<style scoped>
.login-page {
    min-height: 100vh;
    background: #f5f6fa;
}

/* ===== 顶部 ===== */
.login-header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    padding: 60px 30px 40px;
    border-radius: 0 0 30px 30px;
}

.logo-area {
    text-align: center;
    color: #fff;
}

.logo-icon {
    font-size: 48px;
    display: block;
    margin-bottom: 8px;
}

.logo-title {
    font-size: 28px;
    font-weight: 700;
    letter-spacing: 2px;
    margin: 0;
}

.logo-desc {
    font-size: 14px;
    opacity: 0.8;
    margin-top: 6px;
    letter-spacing: 4px;
    opacity: .7;
}

/* ===== 表单 ===== */
.login-form {
    margin: -20px 20px 0;
    background: #fff;
    border-radius: 16px;
    padding: 24px 16px 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

/* 注意：Vant 2 的 Field 样式穿透需要用 ::v-deep 或 /deep/ */
.login-form ::v-deep .van-field {
    padding: 12px 0;
}

.login-form ::v-deep .van-field__label {
    width: 60px;
}

.captcha-btn {
    height: 30px;
    font-size: 12px;
    border-radius: 4px;
}

/* ===== 登录按钮 ===== */
.form-actions {
    margin-top: 20px;
}

.login-btn {
    height: 44px;
    font-size: 16px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border: none;
}

.login-btn:active {
    opacity: 0.8;
}

/* ===== 底部 ===== */
.form-footer {
    text-align: center;
    margin-top: 16px;
    font-size: 14px;
    color: #999;
}

.form-footer .link {
    color: #667eea;
    font-weight: 600;
    cursor: pointer;
}

.form-footer .link:hover {
    text-decoration: underline;
}

/* ===== 其他登录方式 ===== */
.other-login {
    margin: 30px 20px 20px;
}

.divider {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ccc;
    font-size: 13px;
}

.divider::before,
.divider::after {
    content: '';
    flex: 1;
    height: 1px;
    background: #eee;
}

.divider::before {
    margin-right: 16px;
}

.divider::after {
    margin-left: 16px;
}

.social-icons {
    display: flex;
    justify-content: center;
    gap: 40px;
    margin-top: 16px;
    opacity: .5;
}

.social-icons .van-icon {
    cursor: pointer;
    transition: transform 0.2s ease;
}

.social-icons .van-icon:active {
    transform: scale(0.9);
}
</style>